import { changePasswordActionsStyles } from "@insite/content-library/Widgets/ChangePassword/ChangePasswordActions";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

changePasswordActionsStyles.saveButton = {
    css: css`
        width: 100%;
        border-radius: 0;
        padding: 10px 34px;
        background: ${getColor("primary")};
        border: 2px solid ${getColor("primary")};
        span[class^="TypographyStyle"] {
            color: ${getColor("secondary")};
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
        }
        &:hover {
            background: ${getColor("text.accent")};
            /* border: 2px solid  background: ${getColor("text.accent")}; */
            span[class^="TypographyStyle"] {
                color: ${getColor("secondary")};
            }
        }
    `,
};
changePasswordActionsStyles.cancelButton = {
    css: css`
        width: 100%;
        border-radius: 0;
        padding: 10px 34px;
        background: ${getColor("common.background")};
        border: 2px solid ${getColor("primary")} !important;
        &:hover {
            background: ${getColor("common.background")};
            border: 2px solid ${getColor("text.accent")} !important;
        }

        span[class^="TypographyStyle"] {
            color: ${getColor("text.main")};
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
            &:hover {
                color: ${getColor("text.accent")};
            }
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    padding: 10px 34px;
                `,
                null,
                null,
                null,
                null,
            ])};
    `,
};
